import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import { PaymentIntent, PaymentStripeClient, PaymentStripeIntentionService } from './PaymentService'
import { useToast } from '@chakra-ui/toast'
import useAuthContext from '../../hooks/useAuthContext';

const queryPayment = () => {
  const toast = useToast();
  const { user } = useAuthContext();
  const queryClient = useQueryClient();

  const paymentStripeSetup = () => {
    const {data, isLoading, isError, error} = useQuery(
      ['paymentStripeSetup'],
      () => PaymentStripeClient({ token: user.access_token}),
      {
        refetchOnWindowFocus: false,
        onError: () => {
          toast({
            title: 'Error',
            description: 'No se pudo conectar con el servicio de pago',
            status: 'error',
            duration: 2000,
            isClosable: true,
          })
        },
      }
    )

    const dataResponse = data?.data.data

    return {data: dataResponse, isLoading, isError, error}
  }
  const paymentStripeIntent = (id) => {
    const {data, isLoading, isError, error} = useQuery(
      ['paymentStripeIntent'],
      () => PaymentStripeIntentionService({ 
        token: user.access_token,
        recharge_id: id
      }),
      {
        refetchOnWindowFocus: false,
        cacheTime: 0,
        onError: () => {
          toast({
            title: 'Error',
            description: 'No se pudo conectar con el servicio de pago',
            status: 'error',
            duration: 2000,
            isClosable: true,
          })
        },
        enabled: !!id,
      }
    )

    const dataResponse = data?.data.data

    return {data: dataResponse, isLoading, isError, error}
  }

  const rechargeDo = () => {
    const { mutation, ...rest } = useMutation(
      (data) => PaymentIntent({ 
        token: user?.access_token, ...data }),
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['contactsRechargesByUser'])
          queryClient.invalidateQueries(['userPoints'])
        },
        onError: (error) => {
          const errorMessages = {
            404: { title: 'Error', description: 'La recarga no fue encontrada', status: 'error' },
            402: { title: 'Aviso', description: 'Esta recarga ya fue procesada', status: 'info' },
            401: { title: 'Error', description: 'No tienes permiso para realizar esta recarga', status: 'error' },
          };

          const msg = errorMessages[error.status];
          if (msg) {
            toast({
              title: msg.title,
              description: msg.description,
              status: msg.status,
              duration: 4000,
              isClosable: true,
              position: 'top-right',
            });
          } else if (error.status !== 406) {
            toast({
              title: 'Error',
              description: 'No se pudo realizar la recarga, inténtelo más tarde',
              status: 'error',
              duration: 4000,
              isClosable: true,
              position: 'top-right',
            });
          }
        },
      }
    )

    return { mutation, ...rest }
  }

  return {paymentStripeSetup, paymentStripeIntent, rechargeDo}
}

export default queryPayment;